<template>
  <div id="c-modal">
    <button v-if="!hideButton" @click="show()">{{ Text }}</button>
    <modal :name="modalName" :width="width" :height="height" :scrollable="true">
      <div class="modal_header">
        <h3>{{ headerText }}</h3>
        <button
          @click="hide()"
          title="Close (Esc)"
          type="button"
          class="mfp-close"
        ></button>
      </div>
      <div class="modal_body">
        <slot name="content" />
      </div>
      <div class="modal_footer" v-if="visibleFooter">
        <div class="saveButton">
          <a href="#" class="btn_1 mb_5" @click.prevent="onClickSubmit()">{{
            submitText
          }}</a>
        </div>
      </div>
    </modal>
  </div>
</template>
<script>
import('./style.css');

export default {
  name: 'CustomModal',
  props: {
    modalName: {
      type: String,
      default: 'my-first-modal',
    },
    hideButton: {
      type: Boolean,
      default: false,
    },
    headerText: {
      type: String,
      default: 'Modal',
    },
    submitText: {
      type: String,
      default: 'Submit',
    },
    width: {
      type: [String, Number],
      default: '',
    },
    height: {
      type: [String, Number],
      default: 'auto',
    },
    Text: {
      type: String,
      default: 'Click',
    },
    visibleFooter: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    show(modalName = this.modalName ? this.modalName : 'my-first-modal') {
      this.$modal.show(modalName);
    },
    hide() {
      this.$modal.hide(this.modalName);
    },
    onClickSubmit() {
      this.$emit('onClickSubmit');
    },
  },
  mount() {
    // this.show();
  },
};
</script>
<style scoped>
.mfp-close {
  color: firebrick;
}
</style>
